import { IVROption } from '../../../objects/call/ivr/ivr-option/ivr-option';
import { VoiceResponseCommand } from '../../../objects/voice-response-command/generic/voice-response-command';
import { Play } from '../../../objects/voice-response-command/play/play';
import { PlayOrSay } from '../../../objects/voice-response-command/play-or-say/play-or-say';
import { VRCAudioMetadata } from '../../../objects/voice-response-command/vrc-audio-metadata/vrc-audio-metadata/vrc-audio-metadata';

import { GetEditableVrcAudiosByRoleInput } from './interfaces';

export const getEditableVrcAudiosByRole = (params: GetEditableVrcAudiosByRoleInput): VRCAudioMetadata[] => {
  const { vrcAudios, adminRoles, ivrs, roles } = params;

  if (!adminRoles.isPwpAdmin() && !roles.isOrgAdmin()) {
    return [];
  }

  if (adminRoles.isPwpAdmin()) {
    return vrcAudios;
  }

  const protectedAudioIds = new Set<string>();
  const collectProtectedAudioIds = (commands: VoiceResponseCommand[] = []) => {
    for (const command of commands) {
      if (command instanceof PlayOrSay || command instanceof Play) {
        protectedAudioIds.add(command.getAudioId());
      }
    }
  };

  for (const ivr of ivrs) {
    ivr.getOptions().forEach((option: IVROption) => collectProtectedAudioIds(option.getCommands()));
    collectProtectedAudioIds(ivr.getInvalidKeyPressedCommands());
    collectProtectedAudioIds(ivr.getOnFailure());
  }

  return vrcAudios.filter((audio) => !protectedAudioIds.has(audio.getId()));
};
